import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
export var DialogDisconnect = function () {
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.alert_connectionLost_title, className: IdStyles.ModalBackground },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.alert_connectionLost_desc }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/disconnect-dialog/DialogDisconnect.tsx
// module id = 2813
// module chunks = 3